export default __webpack_public_path__ + "static/media/Tt.a1fbf174.wav";